module.exports = __webpack_public_path__ + "img/fp-logo.2e3d4973.png";